<jha-app routeMatchPrefix="">
  <main-header class="rui-app-header"></main-header>
  <main-nav class="rui-app-nav"></main-nav>
</jha-app>
<jha-dialog-box
  jhaTitle="Error Handler"
  [(jhaShowDialog)]="errorMessage"
  (jhaClose)="errorMessageText = ''; errorMessage = false">
  <jha-inline-notification jhaType="Error" jhaIconType="Error">
    <p>{{ errorMessageTextDisplay }}</p>
  </jha-inline-notification>
  <jha-dialog-box-button
    id="danger-dialog-ok"
    jhaText="OK"
    jhaButtonStyle="Primary"></jha-dialog-box-button>
</jha-dialog-box>

<ng-container *ngIf="loading">
  <jha-busy-indicator></jha-busy-indicator>
</ng-container>

<jha-question
  jhaTitle="{{ switchInstQuestion }}"
  [(jhaShowQuestion)]="showSwitchInstitution"
  (jhaClose)="closesSwitchInstitutionPopup($event)">
  <jha-dialog-box-button
    jhaText="Sure"
    jhaButtonStyle="Primary"></jha-dialog-box-button>
  <jha-dialog-box-button jhaText="Close"></jha-dialog-box-button>
</jha-question>

<jha-question
  jhaTitle="Do you wish to log out?"
  [(jhaShowQuestion)]="showLogout"
  (jhaClose)="closesLogoutPopup($event)">
  <jha-dialog-box-button
    data-test="userOptionsLogoutBtn"
    jhaText="Log Out"
    jhaButtonStyle="Primary"></jha-dialog-box-button>
  <jha-dialog-box-button jhaText="Cancel"></jha-dialog-box-button>
</jha-question>
